import { GetAllProfession } from '~/domain/usecases/profession/redux';
import {
  iActionGetAll,
  iActionGetAllSuccess,
  iActionGetAllFailed,
  ProfessionTypes,
} from '~/domain/interfaces/redux/profession/getAll';

export const getAllRequest = (
  payload: GetAllProfession.Params,
): iActionGetAll => ({
  type: ProfessionTypes.GETALL,
  payload,
});

export const getAllSuccess = (
  params: GetAllProfession.Model,
): iActionGetAllSuccess => ({
  type: ProfessionTypes.GETALL_SUCCESS,
  payload: params,
});

export const getAllFailed = (): iActionGetAllFailed => ({
  type: ProfessionTypes.GETALL_FAILED,
});
